import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/product-logo/jumbopack-active.svg'


const _hoisted_1 = { class: "flex flex-row gap-x-4" }
const _hoisted_2 = { class: "flex flex-col rounded-md w-1/2 bg-white border border-gray-lp-1400" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-1000 w-full p-4 rounded-t-md flex flex-row items-center gap-x-2" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "h-6",
    style: {"background":"#B82025","width":"6px"}
  }),
  /*#__PURE__*/_createVNode("p", { class: "text-20px font-montserrat font-semibold text-gray-lp-300" }, " Detail Paket ")
], -1)
const _hoisted_4 = { class: "grid grid-cols-2 p-4 gap-y-5 gap-x-2" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex flex-col rounded-t-md w-1/2 bg-white border border-gray-lp-1400" }
const _hoisted_8 = { class: "bg-gray-lp-1000 w-full p-4 rounded-md flex flex-row items-center gap-x-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "h-6",
  style: {"background":"#B82025","width":"6px"}
}, null, -1)
const _hoisted_10 = { class: "text-20px font-montserrat font-semibold text-gray-lp-300" }
const _hoisted_11 = { class: "grid grid-cols-2 p-4 gap-y-5 gap-x-2" }
const _hoisted_12 = { class: "w-full  p-4 gap-y-5 gap-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Chips = _resolveComponent("Chips")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_DataWrapper, {
          label: "No. STT",
          value: _ctx.data.sttNo,
          fontSize: 14
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.productType'),
          value: _ctx.data.sttProductTypeName,
          fontSize: 14
        }, {
          default: _withCtx(() => [
            (
              _ctx.data.sttProductTypeName.toUpperCase() === 'JUMBOPACK' ||
                _ctx.data.sttProductTypeName.toUpperCase() === 'JUMBOPACKH2H'
            )
              ? (_openBlock(), _createBlock("img", _hoisted_5))
              : (_openBlock(), _createBlock("p", _hoisted_6, "-"))
          ]),
          _: 1
        }, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.weight'),
          value: _ctx.formattedWeight,
          fontSize: 14,
          "data-testid": "urgent-management-taken-berat-value"
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: "Status Terakhir",
          fontSize: 14
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Chips, {
              rounded: "",
              class: "font-medium mt-2",
              label: _ctx.statusChipsStyle.label,
              color: _ctx.statusChipsStyle.color,
              textColor: _ctx.statusChipsStyle.textColor
            }, null, 8, ["label", "color", "textColor"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("urgentDeliveryManagement.detail.detailReceiver")), 1)
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.recipientName'),
          value: _ctx.data.sttRecipientName,
          fontSize: 14
        }, null, 8, ["label", "value"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.recipientPhone'),
          value: _ctx.phoneNumber,
          fontSize: 14
        }, null, 8, ["label", "value"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.recipientAddress'),
          value: _ctx.data.sttRecipientAddress,
          fontSize: 14
        }, null, 8, ["label", "value"])
      ])
    ])
  ]))
}